/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { useEffect } from 'react';

const PORTAL_LAYER_SELECTOR = '.MuiPopover-root, .MuiMenu-root, .MuiDialog-root, .MuiModal-root, .MuiPopper-root';

const shouldIgnoreClickOutside = (target, drawerRoot) => {
  if (drawerRoot?.contains?.(target)) {
    return true;
  }

  return Boolean(target?.closest?.(PORTAL_LAYER_SELECTOR));
};

export const useCommandIntelligenceOverlapAutoHide = ({
  enabled,
  isOpen,
  layoutMode,
  autoHideOnClickOutside,
  drawerRootRef,
  onClose,
}) => {
  useEffect(() => {
    if (!enabled || !isOpen || layoutMode !== 'overlap' || !autoHideOnClickOutside) {
      return undefined;
    }

    const handlePointerDown = event => {
      const target = event?.target;

      if (shouldIgnoreClickOutside(target, drawerRootRef?.current)) {
        return;
      }

      onClose?.(event, 'clickOutside');
    };

    document.addEventListener('pointerdown', handlePointerDown, true);

    return () => document.removeEventListener('pointerdown', handlePointerDown, true);
  }, [autoHideOnClickOutside, drawerRootRef, enabled, isOpen, layoutMode, onClose]);
};
